<template>
  <div class="page-wrap">
    <div class="panel-card">

      <!-- Header -->
      <div class="panel-header">
        <div class="panel-header__icon"><i class="fa fa-archive"></i></div>
        <div class="panel-header__text">
          <div class="panel-header__title">Archival Plans</div>
          <div class="panel-header__sub">Manage archival durations and rates</div>
        </div>
        <div class="panel-header__action">
          <button class="btn-add" @click="showModal">
            <i class="fa fa-plus"></i> Add Archival
          </button>
        </div>
      </div>

      <!-- Loading -->
      <div class="state-box" v-if="loadingData">
        <div class="state-spinner"></div>
        <span>Loading archivals…</span>
      </div>

      <!-- Empty -->
      <div class="state-box state-box--muted" v-else-if="!loadingData && getArchivalData.data.length === 0">
        <i class="fa fa-archive state-box__icon"></i>
        <div class="state-box__title">No archival plans yet</div>
        <div class="state-box__sub">Add the first archival plan to get started</div>
      </div>

      <!-- Table -->
      <div class="table-wrap" v-else>
        <table class="arch-table">
          <thead>
            <tr>
              <th class="th-sm">#</th>
              <th class="th-name">Name</th>
              <th class="th-num">Duration (Yrs)</th>
              <th class="th-num">Default Rate</th>
              <th class="th-num">Tax (%)</th>
              <th class="th-num">Commission ($)</th>
              <th class="th-action">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in getArchivalData.data" :key="item.id">
              <td class="td-sm">{{ index + 1 }}</td>
              <td class="td-name">{{ item.name }}</td>
              <td class="td-num">{{ item.duration }}</td>
              <td class="td-num">${{ item.default_rate | toFixed2 }}</td>
              <td class="td-num">{{ item.tax_percentage || 0 }}%</td>
              <td class="td-num">${{ item.commission_percentage | toFixed2 }}</td>
              <td class="td-action">
                <button class="dots-btn" @click.stop="toggleMenu(index, $event)">
                  <i class="fa fa-ellipsis-v"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 3-dot dropdown -->
    <div class="dot-menu" v-if="activeMenu !== null" :style="{ top: menuPos.top + 'px', right: menuPos.right + 'px' }"
      @click.stop>
      <button class="dot-item" @click="edit(menuItem); activeMenu = null">
        <i class="fa fa-pencil-alt"></i> Edit
      </button>
      <button class="dot-item dot-item--del" @click="openDeleteModal(menuItem.id); activeMenu = null">
        <i class="fa fa-trash"></i> Delete
      </button>
    </div>

    <!-- Archival form modal -->
    <archival v-if="ModalShow" v-on:closemodal="closeModal" :show-modal="ModalShow" :archival="archivalData"
      :is_edit="is_edit" />

    <!-- Delete modal -->
    <transition name="modal-fade">
      <div class="del-overlay" v-if="deleteModal.show" @click.self="deleteModal.show = false">
        <div class="del-box">
          <div class="del-icon"><i class="fa fa-trash"></i></div>
          <div class="del-title">Delete Archival</div>
          <div class="del-sub">This action cannot be undone. The archival plan will be permanently removed.</div>
          <div class="del-actions">
            <button class="del-cancel" @click="deleteModal.show = false">Cancel</button>
            <button class="del-confirm" @click="confirmDelete">Delete</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {
  FETCH_ARCHIVAL,
  DELETE_ARCHIVAL,
} from "@/core/services/store/actions.type";
import archival from "@/pages/backend/master/archivals/archival";
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import { mapGetters } from "vuex";

export default {
  components: { archival },
  computed: {
    ...mapGetters(["currentUser", "getArchivalData"]),
  },
  filters: {
    toFixed2(val) { return parseFloat(val || 0).toFixed(2); },
  },
  data() {
    return {
      loadingData: false,
      ModalShow: false,
      is_edit: false,
      archivalData: { id: 0, name: "", duration: "", default_rate: 0, additional_rate: 0, has_additional_rate: false, tax_percentage: 0, commission_percentage: 0 },
      activeMenu: null,
      menuPos: { top: 0, right: 0 },
      menuItem: null,
      deleteModal: { show: false, id: null },
      breadCrumbs: [
        { id: 1, title: "Dashboard", route: "client.dashboard" },
        { id: 2, title: "Archival List", route: "" },
      ],
    };
  },
  mounted() {
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
    this.$store.dispatch(FETCH_ARCHIVAL);
    document.addEventListener("click", this.closeMenu);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeMenu);
  },
  methods: {
    showModal() {
      this.archivalData = { id: 0, name: "", duration: "", default_rate: 0, additional_rate: 0, has_additional_rate: false, tax_percentage: 0, commission_percentage: 0 };
      this.is_edit = false;
      this.ModalShow = true;
    },
    closeModal() {
      this.ModalShow = false;
      this.$store.dispatch(FETCH_ARCHIVAL);
    },
    edit(item) {
      this.archivalData = { ...item };
      this.is_edit = true;
      this.ModalShow = true;
    },
    toggleMenu(index, event) {
      if (this.activeMenu === index) { this.activeMenu = null; return; }
      const r = event.currentTarget.getBoundingClientRect();
      this.menuPos = { top: r.bottom + 4, right: window.innerWidth - r.right };
      this.menuItem = { ...this.getArchivalData.data[index] };
      this.activeMenu = index;
    },
    closeMenu() { this.activeMenu = null; },
    openDeleteModal(id) {
      this.deleteModal = { show: true, id };
    },
    confirmDelete() {
      const id = this.deleteModal.id;
      this.deleteModal.show = false;
      this.$store.dispatch(DELETE_ARCHIVAL, id)
        .then(() => {
          this.$toastr.s("Archival Deleted");
          this.$store.dispatch(FETCH_ARCHIVAL);
        })
        .catch(err => { this.$toastr.e(err.msg || "Error deleting"); });
    },
  },
};
</script>

<style lang="scss" scoped>
$font: 'Segoe UI', sans-serif;
$blue: #389ad4;
$dark: #0d1b3e;
$border: #dde2ec;

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.page-wrap {
  padding: 12px;
  font-family: $font;
}

/* ── panel card ── */
.panel-card {
  background: #fff;
  border: 1px solid $border;
  border-radius: 16px;
  overflow: clip;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

/* ── header ── */
.panel-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 24px;
  border-bottom: 1px solid $border;
  background: linear-gradient(135deg, #f8faff 0%, #f0f5ff 100%);

  &__icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: linear-gradient(135deg, $blue, #2277aa);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 18px;
    flex-shrink: 0;
  }

  &__text {
    flex: 1;
  }

  &__title {
    font-size: 16px;
    font-weight: 700;
    color: $dark;
    line-height: 1.2;
  }

  &__sub {
    font-size: 12px;
    color: #7a8499;
    margin-top: 3px;
  }

  &__action {
    display: flex;
    align-items: center;
  }
}

.btn-add {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 16px;
  border-radius: 8px;
  border: none;
  background: $blue;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s, box-shadow 0.15s;

  &:hover {
    background: #2d85bb;
    box-shadow: 0 4px 12px rgba(56, 154, 212, 0.35);
  }

  i {
    font-size: 11px;
  }
}

/* ── state boxes ── */
.state-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 56px 24px;
  gap: 8px;
  color: #7a8499;
  font-size: 13px;

  &--muted .state-box__icon {
    color: #c5d0e0;
  }

  &__icon {
    font-size: 36px;
    margin-bottom: 4px;
  }

  &__title {
    font-size: 15px;
    font-weight: 600;
    color: $dark;
  }

  &__sub {
    font-size: 13px;
  }
}

.state-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #c5d8f5;
  border-top-color: $blue;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  margin-bottom: 8px;
}

/* ── table ── */
.table-wrap {
  overflow-x: auto;
  overflow-y: auto;
  max-height: calc(100vh - 200px);
}

.arch-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  color: $dark;

  th {
    position: sticky;
    top: 0;
    z-index: 1;
    padding: 10px 16px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #7a8499;
    border-bottom: 2px solid $border;
    white-space: nowrap;
    background: #fafbfd;
  }

  .th-sm {
    width: 52px;
    text-align: center;
  }

  .th-name {
    width: 30%;
  }

  .th-num {
    width: 120px;
    text-align: right;
  }

  .th-action {
    width: 60px;
    text-align: center;
  }

  td {
    padding: 11px 16px;
    border-bottom: 1px solid #f0f2f8;
    vertical-align: middle;
  }

  tr:hover td {
    background: #f8fbff;
  }

  tr:last-child td {
    border-bottom: none;
  }

  .td-sm {
    text-align: center;
    color: #a0aab8;
    font-size: 12px;
  }

  .td-name {
    font-weight: 500;
  }

  .td-num {
    text-align: right;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
  }

  .td-action {
    text-align: center;
  }
}

/* ── 3-dot ── */
.dots-btn {
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 7px;
  background: transparent;
  color: #a0aab8;
  font-size: 14px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s, color 0.15s;

  &:hover {
    background: #f0f3fa;
    color: $dark;
  }
}

.dot-menu {
  position: fixed;
  z-index: 9999;
  background: #fff;
  border: 1.5px solid $border;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(13, 27, 62, 0.12);
  padding: 4px;
  min-width: 130px;
}

.dot-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 12px;
  border: none;
  background: transparent;
  font-size: 13px;
  font-family: $font;
  color: $dark;
  cursor: pointer;
  border-radius: 7px;
  text-align: left;
  transition: background 0.12s;

  i {
    font-size: 12px;
    color: #7a8499;
  }

  &:hover {
    background: #f4f6fb;
  }

  &--del {
    color: #b42318;

    i {
      color: #b42318;
    }

    &:hover {
      background: rgba(180, 35, 24, 0.07);
    }
  }
}

/* ── delete modal ── */
.del-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(13, 27, 62, 0.45);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.del-box {
  background: #fff;
  border-radius: 16px;
  padding: 32px 28px 24px;
  width: 360px;
  text-align: center;
  box-shadow: 0 20px 60px rgba(13, 27, 62, 0.2);
}

.del-icon {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: rgba(180, 35, 24, 0.1);
  color: #b42318;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 14px;
}

.del-title {
  font-size: 16px;
  font-weight: 700;
  color: $dark;
  margin-bottom: 8px;
}

.del-sub {
  font-size: 13px;
  color: #7a8499;
  line-height: 1.5;
  margin-bottom: 24px;
}

.del-actions {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.del-cancel {
  flex: 1;
  height: 38px;
  border-radius: 8px;
  border: 1.5px solid $border;
  background: #fff;
  color: $dark;
  font-size: 13px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;

  &:hover {
    background: #f4f6fb;
  }
}

.del-confirm {
  flex: 1;
  height: 38px;
  border-radius: 8px;
  border: none;
  background: #b42318;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;

  &:hover {
    background: #8f1a12;
  }
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.2s;
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}
</style>
